import {
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  NumberInput,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck } from "@tabler/icons-react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useEffect } from "react";

interface TestLevelModel {
  id: number;
  code: string | null;
  name: string | null;
  point: number | null;
  createdAt: string | null;
  createdBy: number | null;
  lastUpdatedAt: string | null;
  lastUpdatedBy: number | null;
}

const CUTestLevel = ({ data, onSuccess }: { data?: any; onSuccess: any }) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const form = useForm<TestLevelModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      code: null,
      name: null,
      point: null,
      createdAt: null,
      createdBy: null,
      lastUpdatedAt: null,
      lastUpdatedBy: null,
    },

    validate: {
      code: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Mã không được để trống !";
        }
      },
      name: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Mức độ test không được để trống !";
        }
      },
    },
  });

  const handleCreateTestLevel = async (dataSubmit: TestLevelModel) => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/TechnicalTestLevel/create",
        { ...dataSubmit, point: !dataSubmit.point ? 0 : dataSubmit.point },
      );

      if (res && res.success) {
        NotificationExtension.Success("Tạo mới mức độ test thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleEditTestLevel = async (dataSubmit: TestLevelModel) => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/TechnicalTestLevel/edit",
        { ...dataSubmit, point: !dataSubmit.point ? 0 : dataSubmit.point },
      );

      if (res && res.success) {
        NotificationExtension.Success("Chỉnh sửa mức độ test thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    if (data) {
      form.setValues(data);
    }
  }, [data]);

  return (
    <Box
      component="form"
      maw={600}
      w={"30vw"}
      onSubmit={form.onSubmit((e: TestLevelModel) => {
        if (data) {
          handleEditTestLevel(e);
        } else {
          handleCreateTestLevel(e);
        }
      })}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={12}>
                {" "}
                Hệ thống đang xử lý dữ liệu, vui lòng chờ trong giây lát ...
              </Title>
            </Flex>
          ),
        }}
      />
      <Grid mt={5}>
        <Grid.Col span={{ base: 12, xs: 4 }}>
          <TextInput
            key={form.key("code")}
            label="Mã"
            placeholder="Nhập mã"
            variant={data ? "filled" : "default"}
            readOnly={data}
            withAsterisk={!data}
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 4 }}>
          <TextInput
            key={form.key("name")}
            label="Mức độ test"
            placeholder="Nhập mức độ test"
            withAsterisk
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 4 }}>
          <NumberInput
            key={form.key("point")}
            label="Điểm"
            placeholder="Nhập điểm"
            hideControls
            allowNegative={false}
            min={1}
            {...form.getInputProps("point")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} mt={5}>
        <Button
          type="submit"
          loading={visible}
          disabled={visible}
          leftSection={<IconCheck size={16} />}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CUTestLevel;
